import { useEffect, useState } from "react";
import { getSrcOfIframe } from "../embedUtilities";

const UseYoutubePreview = (url:string, isLoading: boolean, setIsLoading: any, setDisableUpload: any) => {
    const [id, setId] = useState<string>('');
  
    useEffect(() => {
      if (url) {
        setIsLoading(true)
        setId('');
        getYouTubeEmbedId(url)
      }
    },[])

    useEffect(()=> {
      if (id) {
        setDisableUpload(false);
      } else {
        setDisableUpload(true);
      }
      setIsLoading(false);
    }, [id, isLoading])
  
    function getYouTubeEmbedId(youtubeUrl: string){
      let newId = ''
  
      // user enters share link
      if(youtubeUrl.includes('youtu.be')) {
        newId = youtubeUrl.split('youtu.be/')[1]
      }
      // user adds whole iframe embed widget
      else if(youtubeUrl.includes('<iframe')) {
        newId = getSrcOfIframe(youtubeUrl).split('embed/')[1];
      }
      // user copys link from youtube video url
      else if(youtubeUrl.includes('www.youtube.com/watch')) {
        newId = youtubeUrl.split('?v=')[1]
      }
      // user only enters youtube id
      else if(youtubeUrl.split('?')[0].length === 11) {
        newId= youtubeUrl
      }
      //user copies url from embed video iframe widget
      else if(youtubeUrl.startsWith('https://www.youtube.com/embed') || youtubeUrl.startsWith('https://www.youtube-nocookie.com/embed/')) {
        newId = youtubeUrl.split('embed/')[1];
      }
      else if (youtubeUrl.includes('youtube.com/live')){
        newId = youtubeUrl.split('live/')[1];
      }
      else if (youtubeUrl.includes('youtube.com/shorts')) {
        newId = youtubeUrl.split('shorts/')[1];
      }
  
      setId(newId)
      setIsLoading(false);
    }
  
    return {id}
}

export default UseYoutubePreview
